import { ReactNode } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core";
import { InfoOutlined } from "@material-ui/icons";

type FootNoteProps = {
  children: ReactNode;
};

export const Footnote = ({ children }: FootNoteProps) => {
  const classes = useStyles();

  return (
    <div className={classes.warning}>
      <InfoOutlined fontSize="inherit" style={{ marginRight: 12, marginTop: 2 }} />
      {children}
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    warning: {
      display: "flex",
      fontSize: 14,
      lineHeight: 1.36,
      color: theme.palette.battleshipGrey.main,
      fontFamily: theme.typography.fontFamily,
    },
  }),
);
